<template>
    <section class="allubum">
        <AppBackground :title="title"/>
        <v-container>
            <v-row>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="claDia"
                        width='500'
                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg classRoom"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">教室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(claItem, index) in claItems"
                                    :key="index"
                                    :src="claItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="lerDia"
                        width='500'
                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg lerning"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">特別支援教室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(lerItem, index) in lerItems"
                                    :key="index"
                                    :src="lerItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="verDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg veranda"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">ベランダ</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(verItem, index) in verItems"
                                    :key="index"
                                    :src="verItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="corDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg corridor"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">廊下</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(corItem, index) in corItems"
                                    :key="index"
                                    :src="corItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="staDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg stairs"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">階段</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(staItem, index) in staItems"
                                    :key="index"
                                    :src="staItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="eleDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg elevator"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">昇降口</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(eleItem, index) in eleItems"
                                    :key="index"
                                    :src="eleItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="artDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg art"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">美術室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(artItem, index) in artItems"
                                    :key="index"
                                    :src="artItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>

                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="audDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg audiovisual"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">視聴覚室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(audioItem, index) in audioItems"
                                    :key="index"
                                    :src="audioItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="broDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg broadcast"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">放送室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(broadItem, index) in broadItems"
                                    :key="index"
                                    :src="broadItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="cloDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg clothing"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">被服室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(cloItem, index) in cloItems"
                                    :key="index"
                                    :src="cloItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="comDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg computer"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">OA室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(comItem, index) in comItems"
                                    :key="index"
                                    :src="comItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="infDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg infirmary"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">保健室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(infItem, index) in infItems"
                                    :key="index"
                                    :src="infItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="kitDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg kitchenRoom"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">調理室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(kitItem, index) in kitItems"
                                    :key="index"
                                    :src="kitItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="libDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg library"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">図書室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(libItem, index) in libItems"
                                    :key="index"
                                    :src="libItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="m1uDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg music1"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">音楽室1</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(m1uItem, index) in m1uItems"
                                    :key="index"
                                    :src="m1uItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="m2uDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg music2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">音楽室2</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(m2uItem, index) in m2uItems"
                                    :key="index"
                                    :src="m2uItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="sc1Dia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg science1"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">理科室1</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(sc1Item, index) in sc1Items"
                                    :key="index"
                                    :src="sc1Item.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="sc2Dia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg science2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">理科室2</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(sc2Item, index) in sc2Items"
                                    :key="index"
                                    :src="sc2Item.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="couDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg council"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">生徒会室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(couItem, index) in couItems"
                                    :key="index"
                                    :src="couItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="coHDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg councilHed"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">生徒会本部</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(hedItem, index) in hedItems"
                                    :key="index"
                                    :src="hedItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="nagDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg nagomi"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">なごみ</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(nagItem, index) in nagItems"
                                    :key="index"
                                    :src="nagItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="engDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg English"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">イングリッシュルーム</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(engItem, index) in engItems"
                                    :key="index"
                                    :src="engItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="mulDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg multipurposeClass"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">多目的室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(mulItem, index) in mulItems"
                                    :key="index"
                                    :src="mulItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="mu1Dia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg multipurposeHole1"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">多目的ホール１</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(mu1Item, index) in mu1Items"
                                    :key="index"
                                    :src="mu1Item.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="mu2Dia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg multipurposeHole2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">多目的ホール２</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(mu2Item, index) in mu2Items"
                                    :key="index"
                                    :src="mu2Item.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="mu3Dia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg multipurposeHole3"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">多目的ホール３</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(mu3Item, index) in mu3Items"
                                    :key="index"
                                    :src="mu3Item.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="tecDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg technical"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">金工室</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(tecItem, index) in tecItems"
                                    :key="index"
                                    :src="tecItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="gymDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg gym"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">講堂</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(gymItem, index) in gymItems"
                                    :key="index"
                                    :src="gymItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="marDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg martialArts"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">剣道場</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(marItem, index) in marItems"
                                    :key="index"
                                    :src="marItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="groDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg ground"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">グラウンド</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(groItem, index) in groItems"
                                    :key="index"
                                    :src="groItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="basDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg base"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">野球場</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(basItem, index) in basItems"
                                    :key="index"
                                    :src="basItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="sofDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg soft"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">ソフトボール場</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(sofItem, index) in sofItems"
                                    :key="index"
                                    :src="sofItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="tenDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg tennis"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">テニス場</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(tenItem, index) in tenItems"
                                    :key="index"
                                    :src="tenItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="parDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg parking"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">駐輪場</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(parItem, index) in parItems"
                                    :key="index"
                                    :src="parItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="verDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg circle"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">円形校舎</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(cirItem, index) in cirItems"
                                    :key="index"
                                    :src="cirItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
                <v-col xl="2" lg="2" md="1.5" sm="4" xs="5">
                    <v-dialog
                        v-model="etcDia"
                        width='500'

                    >
                        <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="bg etc"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <div class="bg_rgba">
                                        <div class="bg_text">その他</div>
                                    </div>
                                </div>
                        </template>

                            <v-carousel
                                width='85%'
                                height='auto'
                                hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(etcItem, index) in etcItems"
                                    :key="index"
                                    :src="etcItem.src"
                                >
                                </v-carousel-item>
                            </v-carousel>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import AppBackground from './AppBackgroundHolder.vue'
import AllubumItem from '../common/allubumItem'

export default {
    name: "Allubum",
    data () {
        return {
            title: '写真館',
            artDia: false,
            audDia: false,
            basDia: false,
            broDia: false,
            claDia: false,
            cloDia: false,
            comDia: false,
            corDia: false,
            couDia: false,
            coHDia: false,
            eleDia: false,
            engDia: false,
            etcDia: false,
            groDia: false,
            gymDia: false,
            infDia: false,
            kitDia: false,
            lerDia: false,
            libDia: false,
            marDia: false,
            mulDia: false,
            mu1Dia: false,
            mu2Dia: false,
            mu3Dia: false,
            m1uDia: false,
            m2uDia: false,
            nagDia: false,
            parDia: false,
            sc1Dia: false,
            sc2Dia: false,
            sofDia: false,
            staDia: false,
            tecDia: false,
            tenDia: false,
            verDia: false,
            cirDia: false,

            artItems: AllubumItem.art,
            audioItems: AllubumItem.audiovisual,
            basItems: AllubumItem.base,
            broadItems: AllubumItem.broadcast,
            claItems: AllubumItem.classRoom,
            cloItems: AllubumItem.clothing,
            comItems: AllubumItem.computer,
            corItems: AllubumItem.corridor,
            couItems: AllubumItem.council,
            hedItems: AllubumItem.councilHed,
            eleItems: AllubumItem.elevator,
            engItems: AllubumItem.English,
            etcItems: AllubumItem.etc,
            groItems: AllubumItem.ground,
            gymItems: AllubumItem.gym,
            infItems: AllubumItem.infirmary,
            kitItems: AllubumItem.kitchenRoom,
            lerItems: AllubumItem.lerning,
            libItems: AllubumItem.library,
            marItems: AllubumItem.martialArts,
            mulItems : AllubumItem.multipurposeClass,
            mu1Items : AllubumItem.multipurposeHole1,
            mu2Items : AllubumItem.multipurposeHole2,
            mu3Items : AllubumItem.multipurposeHole3,
            m1uItems: AllubumItem.music1,
            m2uItems: AllubumItem.music2,
            nagItems: AllubumItem.nagomi,
            parItems: AllubumItem.parking,
            sc1Items: AllubumItem.science1,
            sc2Items: AllubumItem.science2,
            sofItems: AllubumItem.soft,
            staItems: AllubumItem.stairs,
            tecItems: AllubumItem.technical,
            tenItems: AllubumItem.tennis,
            verItems: AllubumItem.veranda,
            cirItems: AllubumItem.circle,
        }
    },
    components:{
        AppBackground
    }
}
</script>

<style scoped lang='scss'>
.allubum {
    margin-bottom: 100px;
}
.bg {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    background-repeat: no-repeat;
    justify-content: center;
    align-items: center;
    background-size: contain;

    &_rgba {
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;

        &_text {
            font-size: 20px;
        }
    }
}
.art {
    background-image: url(../assets/img/allubumItem/art/sum.webp);
}
.audiovisual {
    background-image: url(../assets/img/allubumItem/audiovisual/sum.webp);
}
.base {
    background-image: url(../assets/img/allubumItem/base/sum.webp);
}
.broadcast {
    background-image: url(../assets/img/allubumItem/broadcast/sum.webp);
}
.classRoom {
    background-image: url(../assets/img/allubumItem/classRoom/sum.webp);
}
.clothing {
    background-image: url(../assets/img/allubumItem/clothing/sum.webp);
}
.computer {
    background-image: url(../assets/img/allubumItem/computer/sum.webp);
}
.corridor {
    background-image: url(../assets/img/allubumItem/corridor/sum.webp);
}
.council {
    background-image: url(../assets/img/allubumItem/council/sum.webp);
}
.councilHed {
    background-image: url(../assets/img/allubumItem/councilHed/sum.webp);
}
.elevator {
    background-image: url(../assets/img/allubumItem/elevator/sum.webp);
}
.English {
    background-image: url(../assets/img/allubumItem/English/sum.webp);
}
.etc {
    background-image: url(../assets/img/allubumItem/etc/sum.webp);
}
.ground {
    background-image: url(../assets/img/allubumItem/ground/sum.webp);
}
.gym {
    background-image: url(../assets/img/allubumItem/gym/sum.webp);
}
.infirmary {
    background-image: url(../assets/img/allubumItem/infirmary/sum.webp);
}
.kitchenRoom {
    background-image: url(../assets/img/allubumItem/kitchenRoom/sum.webp);
}
.lerning {
    background-image: url(../assets/img/allubumItem/lerning/sum.webp);
}
.library {
    background-image: url(../assets/img/allubumItem/library/sum.webp);
}
.martialArts {
    background-image: url(../assets/img/allubumItem/martialArts/sum.webp);
}
.multipurposeClass {
    background-image: url(../assets/img/allubumItem/multipurposeClass/sum.webp);
}
.multipurposeHole1 {
    background-image: url(../assets/img/allubumItem/multipurposeHole1/sum.webp);
}
.multipurposeHole2 {
    background-image: url(../assets/img/allubumItem/multipurposeHole2/sum.webp);
}
.multipurposeHole3 {
    background-image: url(../assets/img/allubumItem/multipurposeHole3/sum.webp);
}
.music1 {
    background-image: url(../assets/img/allubumItem/music1/sum.webp);
}
.music2 {
    background-image: url(../assets/img/allubumItem/music2/sum.webp);
}
.nagomi {
    background-image: url(../assets/img/allubumItem/nagomi/sum.webp);
}
.parking {
    background-image: url(../assets/img/allubumItem/parking/sum.webp);
}
.science1 {
    background-image: url(../assets/img/allubumItem/science1/sum.webp);
}
.science2 {
    background-image: url(../assets/img/allubumItem/science2/sum.webp);
}
.soft {
    background-image: url(../assets/img/allubumItem/soft/sum.webp);
}
.stairs {
    background-image: url(../assets/img/allubumItem/stairs/sum.webp);
}
.technical {
    background-image: url(../assets/img/allubumItem/technical/sum.webp);
}
.tennis {
    background-image: url(../assets/img/allubumItem/tennis/sum.webp);
}
.veranda {
    background-image: url(../assets/img/allubumItem/veranda/sum.webp);
}
.circle {
    background-image: url(../assets/img/allubumItem/circle/sum.jpg);
}

</style>
